// extracted by mini-css-extract-plugin
module.exports = {"overlay":"index_overlay__Cy2Qz","modal":"index_modal__tXh8X"};